import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import TableDefault from "../../../../components/grid/TableDefault";
import { formatDate } from "../../../../utils/formatDate";
import MaskService from "../../../../utils/mask/maskService";
import useConciliacaoBancariaController from "../controllers/ConciliacaoBancariaController";
import moment from "moment";

let typingTimer = null;

const BodySearchMovimentations = ({
  suggestions = [],
  items = [],
  setItems = () => {},
  type = "",
  totalItens = 0,
  filter = "",
  setFilter = () => {},
}) => {
  const rowsPerPage = 10;
  const quantidadePorPesquisa = 50;

  const [loadingTable, setLoadingTable] = useState(false);
  const [pagePropDefault, setPagePropDefault] = useState(0);

  const { getMovimentations } = useConciliacaoBancariaController();

  const customHandleChangePage = async (event, page, itemIndex) => {
    if (!type) return [];
    setLoadingTable(true);
    let pageCarregar = Math.round(itemIndex / quantidadePorPesquisa + 1);
    let itens;

    itens = await getMovimentations({
      type: type,
      newPage: pageCarregar,
      search: true,
      filter: filter,
      whereNull: ["conciliacao_bancaria_id"],
    });

    setLoadingTable(false);
    return itens.data;
  };

  const searchItems = async (textFilter) => {
    setFilter(textFilter);
    if (!type) return [];

    clearTimeout(typingTimer);
    typingTimer = setTimeout(async () => {
      setLoadingTable(true);

      await getMovimentations({
        type: type,
        newPage: 1,
        search: false,
        filter: textFilter,
        whereNull: ["conciliacao_bancaria_id"],
      });
      setLoadingTable(false);
    }, 2000);
  };

  useEffect(() => {
    setPagePropDefault(0);
  }, [filter]);

  return (
    <Grid>
      <Grid item container justifyContent="space-between" alignItems="flex-end">
        <Grid item xs>
          <TextFieldErp
            value={filter}
            onChange={(e) => {
              searchItems(e.target.value);
            }}
            label="Busque por ID, Data, Descrição ou Valor"
            variant="filled"
          />
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <TableDefault
          selected={items || []}
          setSelected={setItems}
          smallFont
          selectable
          columns={[
            {
              label: "ID",
              id: "id",
            },
            {
              label: "Data",
              id: "data",
              format: (item) => {
                let getStandardDate = !!item.data;

                if (getStandardDate)
                  return moment(item.data).format("DD/MM/YYYY HH:mm:ss");
                else {
                  return "-";
                }
              },
            },
            {
              label: "Descrição",
              id: "historico",
            },
            {
              label: "Valor",
              id: "valor",
              format: (item) =>
                `R$ ${MaskService.toMask("decimal", item.valor)}`,
            },
          ]}
          values={suggestions}
          loading={loadingTable}
          quantidadeItensTotal={totalItens}
          rowsPerPage={rowsPerPage}
          customHandleChangePage={customHandleChangePage}
          pageProp={pagePropDefault}
          setPageProp={setPagePropDefault}
          rowId="typeBillID"
          customDisableCheckAll={true}
        />
      </Grid>
    </Grid>
  );
};

export default BodySearchMovimentations;
